module.exports = __webpack_public_path__ + "a5d66875b17cf602ae3a6fb573467c23.png";